import { Link as RouterLink } from "react-router-dom";

import { useDomainServices } from "@/providers/DomainServices";
import { OAuthExchangePage } from "@/shared/components/OAuthCallback/OAuthExchangePage";
import { Goto } from "@/shared/navigation/Goto";

import { MCP_OAUTH_MESSAGES } from "./mcpOAuthMessages";

/**
 * Where an MCP server's OAuth redirect lands: /settings/ai/mcp-callback?code=...&state=...
 * The server_id is recovered from the state token on the backend. The route lives inside the
 * Settings descendant `<Routes>`, so it exchanges in the page ({@link OAuthExchangePage})
 * rather than in a loader.
 */
export function OAuthCallbackHandler() {
  const { mcpRegistryService } = useDomainServices();

  return (
    <OAuthExchangePage
      provider="mcp"
      // Cache freshness is owned by the opener: McpConnections invalidates the token
      // statuses when it receives the success message, so the popup does not.
      exchange={({ code, state, orgId }) =>
        mcpRegistryService.oauthCallback({ code, state }, orgId)
      }
      messageTypes={MCP_OAUTH_MESSAGES}
      loadingMessage="Completing authorization..."
      successMessage="Successfully connected! You can close this window."
      renderError={(reason) => (
        <>
          Authorization failed. {reason} Try again from the{" "}
          <RouterLink to={Goto.route.Settings.AI}>AI settings page</RouterLink>.
        </>
      )}
      standaloneRedirectPath={Goto.route.Settings.AI}
    />
  );
}
